import { axiosInstance } from "../utils/axios";

export const fetchLogo = async () => {
  return axiosInstance.get("/logo").then((res) => ({ data: res.data.result }));
};
